import { Component, computed, forwardRef, inject, input, signal } from '@angular/core';
import { LpActionsService } from '@features/lp/lp-actions/lp-actions.service';
import { LpCanvasComponentsComponent } from '@features/lp/lp-canvas/lp-canvas-components/lp-canvas-components.component';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpDraggableDirective } from '@features/lp/lp-drag-and-drop/lp-draggable.directive';
import { workaroundPivot } from '@shared/workarounds.utils';
import { LpDraggableCanvasComponent } from '@typings/lp/generated';
import { Vector2Screen } from '@typings/vectors';

@Component({
  selector: 'lp-draggable-canvas-component',
  imports: [LpDraggableDirective, forwardRef(() => LpCanvasComponentsComponent)],
  templateUrl: './lp-draggable-canvas-component.component.html',
  styleUrl: './lp-draggable-canvas-component.component.css',
})
export class LpDraggableCanvasComponentComponent {
  comp = input.required<LpDraggableCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();
  pivot = computed(() => workaroundPivot(this.context().element().pivot));
  isDragging = signal(false);

  readonly #lpActionsService = inject(LpActionsService);

  onPositionUpdated(position: Vector2Screen | undefined) {
    this.context().translate(position);
  }

  onStyleUpdated(style: Partial<CSSStyleDeclaration>) {
    if (style.transition) {
      this.context().transition(style.transition);
      delete style.transition;
    }
    this.context().setStyle(style);
  }

  onGrabbed() {
    this.isDragging.set(true);
    this.#lpActionsService.perform(this.comp().onBeginDrag);
  }

  onReleased() {
    this.isDragging.set(false);
    this.#lpActionsService.perform(this.comp().onEndDrag);
  }

  onTargetEntered() {
    this.#lpActionsService.perform(this.comp().onEnterTarget);
  }
}
